<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We may be able to cover your exit fees.</h4>
  <p>
    If your old supplier is asking for exit fees, we may be able to credit the
    equivalent amount to your account when you switch, so you don't miss out for
    looking for a better tariff and service. Just
    <Link :to="ExternalRoute.contactUs" class="link text-primary-600">
      get in touch with our customer support team
    </Link>
    here, or on
    <Link class="link text-primary-600" to="mailto:help@so.energy"
      >help@so.energy</Link
    >
    or
    <Link class="link text-primary-600" to="tel:0330 111 5050"
      >0330 111 5050</Link
    >
    (Mon-Fri 9am-5pm).
  </p>
</template>
